export const legacySizes = {
  xl: 32,
  lg: 24,
  md: 20,
  sm: 14,
  xs: 10,
} as const

export function getSize(size: string | number) {
  const defaultSize = 16

  if (typeof size === 'string') {
    return legacySizes[size as keyof typeof legacySizes] || defaultSize
  }

  return size
}
